//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getInstagramShopsFeatureUgc } from '@instagram-account/redux/instagram-shops/selectors/getInstagramShopsFeatureUgc';
import { Normalized } from '@utils/normalize';

export const getInstagramShopsItems = createSelector(
  getInstagramShopsFeatureUgc,
  (featureUgc) => featureUgc.items,
);

export const getOrderedInstagramShopsItems = createSelector(
  getInstagramShopsItems,
  (normalizedInstagramShopItems) =>
    Normalized.getOrdered(normalizedInstagramShopItems),
);
